var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed-btn"},[_c('img',{attrs:{"src":require("@/assets/img/orderGeneral/order_concat_servicer@2x.png")},on:{"click":_vm.clickPhone}}),_c('a',{ref:"telPhone2",staticStyle:{"display":"none"},attrs:{"href":`tel:${_vm.phone}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }